import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  FormFeedback,
} from 'reactstrap';
import * as Yup from 'yup';
import DatePicker from 'react-datepicker';
import { useFormik } from 'formik';

function SubscriptionModal(props) {
  const {
    formCallback,
    editFlow = false,
    initialValues = {},
    reset = false,
    resetFun,
    modalFlag,
    toggleFunc,
  } = props;

  const validationSchema = Yup.object({
    invoiceSendInterval: Yup.number()
      .required('Interval is Required')
      .test(
        'Is positive?',
        'The number must be greater than 0',
        (value) => value > 0
      ),
    subscriptionStartDate: Yup.string().required(
      'Subscription start date is Required'
    ),
    subscriptionEndDate: Yup.string().required(
      'Subscription end date is Required'
    ),
  });

  //dateChange
  const dateChange = (date) => {
    setValues({ ...values, subscriptionStartDate: date || '' });
  };

  const dateChangeSecond = (date) => {
    setValues({ ...values, subscriptionEndDate: date || '' });
  };

  const {
    handleChange,
    resetForm,
    values,
    handleSubmit,
    errors,
    touched,
    setValues,
  } = useFormik({
    initialValues: initialValues,
    validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      formCallback(values);
    },
  });

  return (
    <Modal
      isOpen={modalFlag}
      toggle={toggleFunc}
      style={{ top: '185px', left: '81px' }}
    >
      <ModalHeader toggle={toggleFunc}>Subscription</ModalHeader>
      <ModalBody>
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Label for="invoiceSendInterval">Invoice Interval (in Days)</Label>
            <Input
              type="number"
              name="invoiceSendInterval"
              id="invoiceSendInterval"
              onChange={handleChange}
              value={values.invoiceSendInterval}
              placeholder="Enter Invoice Interval (in Days)"
              min={1}
              invalid={
                errors.invoiceSendInterval && touched.invoiceSendInterval
                  ? true
                  : false
              }
            />
            <FormFeedback>
              {errors.invoiceSendInterval && touched.invoiceSendInterval
                ? errors.invoiceSendInterval
                : ''}
            </FormFeedback>
          </FormGroup>

          <FormGroup>
            <Label for="subscriptionStartDate">Subscription Start Date</Label>
            <br />
            <DatePicker
              name="subscriptionStartDate"
              className={'form-control'}
              style={{
                zIndex: '9999 !important',
                width: '100% !important',
              }}
              selected={values.subscriptionStartDate}
              onChange={dateChange}
              minDate={Date.now()}
              placeholderText="Subscription Start Date"
              width="100%"
              popperPlacement="top-end"
              popperModifiers={{
                flip: {
                  behavior: ['bottom'],
                },
                preventOverflow: {
                  enabled: false,
                },
                hide: {
                  enabled: false,
                },
              }}
            />
            <div className="error">
              {errors.subscriptionStartDate && touched.subscriptionStartDate
                ? errors.subscriptionStartDate
                : ''}
            </div>
          </FormGroup>

          <FormGroup>
            <Label for="subscriptionEndDate">Subscription End Date</Label>
            <br />
            <DatePicker
              name="subscriptionEndDate"
              className="form-control"
              style={{
                zIndex: '9999 !important',
                width: '100% !important',
              }}
              selected={values.subscriptionEndDate}
              onChange={dateChangeSecond}
              minDate={Date.now()}
              placeholderText="Subscription End Date"
              width="100%"
              popperPlacement="top-end"
              popperModifiers={{
                flip: {
                  behavior: ['bottom'],
                },
                preventOverflow: {
                  enabled: false,
                },
                hide: {
                  enabled: false,
                },
              }}
            />
            <div className="error">
              {errors.subscriptionEndDate && touched.subscriptionEndDate
                ? errors.subscriptionEndDate
                : ''}
            </div>
          </FormGroup>
          <Button type="submit">
            {editFlow == 'edit' ? 'Save' : 'Submit'}
          </Button>
          {reset && <Button onClick={resetFun}>Reset</Button>}
        </Form>
      </ModalBody>
    </Modal>
  );
}

export default SubscriptionModal;
